import { TFunction } from 'i18next';
import { Dayjs } from 'dayjs';
import { IconClipboardCheck } from '@tabler/icons-react';
import { Options } from '@/components/Controls/Select';
import {
  EntityFilterSelect,
  FilterDateRange,
  FilterEntity,
  FilterGrid,
  FilterSwitch,
} from './FilterKit';

type VehicleFilterProps = {
  t: TFunction<undefined>;
  isLoadingAllGroups?: boolean;
  isLoadingAllCompanies?: boolean;
  groupOptions?: Options[];
  companyOptions?: Options[];
  displayGroupFilter?: boolean;
  displayCompanyFilter?: boolean;
  startDate?: string;
  endDate?: string;
  requestInspection?: string;
  groupId?: string;
  companyId?: string;
  searchBeginDate?: (value: Dayjs) => void;
  searchEndDate?: (value: Dayjs) => void;
  searchByRequestInspect?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchByGroup?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  searchByCompany?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const VehicleFilter = ({
  t,
  isLoadingAllGroups,
  isLoadingAllCompanies,
  groupOptions,
  companyOptions,
  displayGroupFilter,
  displayCompanyFilter,
  startDate,
  endDate,
  requestInspection,
  groupId,
  companyId,
  searchBeginDate,
  searchEndDate,
  searchByRequestInspect,
  searchByGroup,
  searchByCompany,
}: VehicleFilterProps) => {
  return (
    <FilterGrid>
      <FilterDateRange
        label={t('common:createdBetween')}
        startDate={startDate}
        endDate={endDate}
        onStartChange={searchBeginDate}
        onEndChange={searchEndDate}
        className="sm:col-span-2"
      />
      {displayGroupFilter && (
        <EntityFilterSelect
          entity={FilterEntity.GROUP}
          label={t('common:linkedToGroup')}
          options={groupOptions}
          value={groupId}
          loading={isLoadingAllGroups}
          onChange={searchByGroup}
        />
      )}
      {displayCompanyFilter && (
        <EntityFilterSelect
          entity={FilterEntity.COMPANY}
          label={t('common:linkedToCompany')}
          options={companyOptions}
          value={companyId}
          loading={isLoadingAllCompanies}
          emptyMessage={
            groupId
              ? t('common:noCompanyLinkedToThisGroup')
              : t('common:youAreNotLinkedToAnyCompany')
          }
          onChange={searchByCompany}
        />
      )}
      <FilterSwitch
        icon={IconClipboardCheck}
        tone="orange"
        label={t('vehiculeInspectionRequest')}
        checked={requestInspection === 'true'}
        onChange={searchByRequestInspect}
      />
    </FilterGrid>
  );
};
